import { createTrackClient } from './createTrackClient'

export { createTrackClient } from './createTrackClient'

/** The shell uses `atlas` because its events belong to no product app. */
export const track = createTrackClient('atlas')
